import * as uuid from "uuid";

import sqftConfig from "../../store/sqftConfig";
import workspace from "../workspace";
import EventManager from "../../store/sqftEventManager";
import {
  getMidPoint,
  getPointDistance,
  getPointField,
  isApproximatelyEqual,
  orientation
} from "../../../../helpers/sqftHelper";
import {
  DIRECTIONS,
  getLineDirection,
  getLineLengthNumberTextV2ForTheImage,
  getLineOrientation,
  getPointDirection
} from "../../../../helpers/shapeHelper";
import {isPointInsidePolygon} from "../../../../lib/pnpoly";
import {getLineBordersArrayV2} from "../../helpers/lineHelper";
import moveDiagonalLine from "../../../../lib/moveDiagonalLine";
import SqftStore from "../../store/sqftStore";
import COLOR_THEMES from "../../../../../../colorThemes";
import store from "../../../../../../store";
import {SIDEBAR_NAVIGATION_BUTTONS} from "../../../../constants";
import {expandLineLeftAndRightParts} from "./overlays/expandLineLeftAndRightParts";

class SimpleLine {
  id;
  from;
  to;
  parent;
  settings;
  lineLengthText;

  constructor(from, to, parent, settings = {isResizable: true}) {
    this.id = uuid.v4();
    this.from = from;
    this.to = to;
    this.parent = parent;
    this.settings = settings;
    this.design = {
      lineThickness: 1,
      lineHoveredArea: 10
    };
    this.state = {
      isHovering: false,
      mouseDown: false,
      mouseDownPosition: null,
      movePointDistance: null
    };
    this.initLineLength(settings.isResizable);
    this.initEvents();
  }

  exportData = () => {
    return {
      id: this.id,
      from: this.from.exportData(),
      to: this.to.exportData()
    }
  }

  importData = (lineData) => {
    this.id = lineData.id;
    this.from.importData(lineData.from);
    this.to.importData(lineData.to);
  }

  isHovering = () => {
    return this.state.isHovering
  }

  getParent = () => {
    return this.parent
  }

  initEvents = () => {
    EventManager.addEvent(
      EventManager.events.MOUSE_MOVE,
      this.onMouseMove,
      this,
      EventManager.priorities.IMAGE_LINE
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_DOWN,
      this.onMouseDown,
      this,
      EventManager.priorities.IMAGE_LINE
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_UP,
      this.onMouseUp,
      this,
      EventManager.priorities.IMAGE_LINE
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_LEAVE,
      this.onMouseLeave,
      this,
      EventManager.priorities.OVERALL
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_LEAVE,
      this.onMouseLeave,
      this,
      EventManager.priorities.OVERALL
    );
    EventManager.addEvent(
      EventManager.events.RENDER,
      this.render,
      this,
      EventManager.priorities.IMAGE_LINE
    );
  };

  initLineLength = (isResizable = true) => {
    this.lineLengthText = getLineLengthNumberTextV2ForTheImage(
      this.from,
      this.to,
      this,
      this.setLineLengthFromNumberValue,
      !isResizable
    );
  }

  destroy = (protect) => {
    if (!protect) {
      EventManager.removeEvent(this);
      this.from.destroy(protect);
      this.lineLengthText.destroy();
    }
  };

  deregisterEvents = () => {
    EventManager.removeEvent(this);
    this.isHidden = true;
    this.from.deregisterEvents();
    this.lineLengthText.deregisterEvents();
  }

  reInitEvents = () => {
    if (this.isHidden) {
      this.initEvents();
      this.isHidden = false;

      this.from.reInitEvents();
      this.lineLengthText.reInitEvents();
    }
  }

  onMouseLeave() {
    this.state.isHovering = false;
    this.state.mouseDown = false;
  }

  onMouseUp(mousePos, e) {
    void mousePos;
    void e;
    if (this.state.mouseDown) {
      this.state.mouseDown = false;
      this.state.mouseDownPosition = null;
      //this.from.snapToGrid();
      //this.to.snapToGrid();
    }
  }
  onMouseDown(mousePos, e) {
    void e;
    if (this.state.isHovering) {
      this.state.mouseDown = true;
      this.state.movePointDistance = getPointDistance(this.from, this.to);
      this.state.mouseDownPosition = mousePos;
      return true;
    }
    return false;
  }

  isMouseOverLineV2 = (mousePos) => {
    const lineBordersArray = getLineBordersArrayV2(this.from,
      this.to,
      this.design.lineHoveredArea
    )
     //this.state.isHovering
    return isPointInsidePolygon(mousePos, lineBordersArray);// || this.state.mouseDown;
  }

  onMouseMove = (mousePos, e) => {
    void e;
    // if (e.terminate && !parent.isHovering()) {
    //   this.state.isHovering = false;
    //   return false;
    // }
    const isMouseOverLine = this.isMouseOverLineV2(mousePos);
    this.state.isHovering = isMouseOverLine;

    if (this.state.mouseDown ||  isMouseOverLine) {
      if (workspace.getAllowEdges() && !this.from.angleIsChanged && !this.to.angleIsChanged) {
        if (this.state.mouseDown && this.settings.isResizable) {
          this.moveLineWithMouse(mousePos);
        }
        EventManager.releaseStealLock(this.parent);
        EventManager.stealCursor();
        switch(getLineOrientation(this.from, this.to)) {
          case orientation.HORIZONTAL:
            EventManager.setCursor("n-resize", this);
            break;
          case orientation.VERTICAL:
            EventManager.setCursor("e-resize", this);
            break;
          case orientation.NORTHWEST:
          case orientation.SOUTHEAST:
            EventManager.setCursor("ne-resize", this);
            break;
          case orientation.NORTHEAST:
          case orientation.SOUTHWEST:
            EventManager.setCursor("nw-resize", this);
            break;
        }
        return this.state.mouseDown;
      }

      if (sqftConfig.highlight.lines && this.state.isHovering) {
        EventManager.releaseStealLock(this.parent);
        EventManager.stealCursor();
        return false;
      }
      // prevent all other mouseover's
    }

    if (workspace.getHoverShape() !== this.parent) {
      this.state.isHovering = false;
    }
    EventManager.resetCursor(this);
    return false;
  }

  setLineLengthFromNumberValue = (newValue) => {
    newValue = newValue / sqftConfig.getMeasureMultiplier()
    const currentDistance = getPointDistance(this.from, this.to);
    const diff = newValue - currentDistance;
    const shape = this.getParent();
    expandLineLeftAndRightParts(shape, this, diff);
    debugger // eslint-disable-line no-debugger

    //adjust parent size
    const currentSize = this.parent.getSize();
    let newImageWidth = currentSize.width;
    let newImageDepth = currentSize.depth;
    const o = getLineOrientation(this.from, this.to);
    //const lineDirection = getLineDirection(this.from, this.to);

    const expandWidth = () => {
      this.parent.setPosition({x: this.parent.pos.x - diff / 2, y: this.parent.pos.y});
      newImageWidth = newValue;

      this.from.x += diff / 2;
      this.to.x += diff / 2;

      //move points for the parallel line
      const parallelLine = this.getParallelLine();
      parallelLine.from.x += diff / 2;
      parallelLine.to.x += diff / 2;

      this.updatePrentSize(newImageWidth, newImageDepth);
    }

    const expandHeight = () => {
      this.parent.setPosition({x: this.parent.pos.x, y: this.parent.pos.y - diff / 2});
      newImageDepth = newValue;

      this.from.y += diff / 2;
      this.to.y += diff / 2;
      //move points for the parallel line
      const parallelLine = this.getParallelLine();
      parallelLine.from.y += diff / 2;
      parallelLine.to.y += diff / 2;

      this.updatePrentSize(newImageWidth, newImageDepth);
    }

    if (o === orientation.VERTICAL) {
      if (isApproximatelyEqual(shape.rotatedDegrees, 0, 3)
        || isApproximatelyEqual(shape.rotatedDegrees, 180, 3)
      ) {
        expandHeight();
      } else {
        expandWidth();
      }
    } else if (o === orientation.HORIZONTAL) {
      if (isApproximatelyEqual(shape.rotatedDegrees, 0, 3)
        || isApproximatelyEqual(shape.rotatedDegrees, 180, 3)
      ) {
        expandWidth();
      } else {
        expandHeight();
      }
    } else {
      // const nextLine = this.parent.getNextLine(this);
      // const prevLine = this.parent.getPrevLine(this);
      // moveDiagonalLine(this, nextLine, prevLine, this.state.movePointDistance, yDiff, o);
      //newImageWidth += xDiff;
      //newImageHeight += yDiff;
    }

    this.parent.updateLinesLength();
    this.parent.updateSnappedPos(); //resolve snapping v1
  }

  moveLineWithMouse = (mousePos) => {

    // console.log("mousePos", mousePos);
    // console.log("this.from.x", this.from.x);
    // console.log("this.from.x", this.to.x);

    const scale = workspace.getScale();
    const xDiff = (this.state.mouseDownPosition.x - mousePos.x) / scale;
    const yDiff = (this.state.mouseDownPosition.y - mousePos.y) / scale;
    const o = getLineOrientation(this.from, this.to);
    if (o === orientation.VERTICAL) {
      this.state.mouseDownPosition.x = mousePos.x;
    } else if (o === orientation.HORIZONTAL) {
      this.state.mouseDownPosition.y = mousePos.y;
    } else {
      this.state.mouseDownPosition = mousePos;
    }

    // console.log("xDiff", xDiff);
    // console.log("yDiff", yDiff);
    // console.log("this.state.mouseDownPosition", this.state.mouseDownPosition);
    // console.log("mousePos", mousePos);
    this.moveLine(xDiff, yDiff);
  };

  moveLine = (xDiff, yDiff) => {
    const currentSize = this.parent.getSize();
    let newImageWidth = currentSize.width;
    let newImageHeight = currentSize.height;

    const o = getLineOrientation(this.from, this.to);
    const lineDirection = getLineDirection(this.from, this.to);

    if (o === orientation.VERTICAL) {
      if (lineDirection === DIRECTIONS.SOUTH) {
        newImageWidth -= xDiff;
        this.from.x -= xDiff;
        this.to.x -= xDiff;
      } else if (lineDirection === DIRECTIONS.NORTH) {
        newImageWidth += xDiff;
        this.parent.setPosition({x: this.parent.pos.x - xDiff, y: this.parent.pos.y});
        this.parent.updateSnappedPos(); //resolve snapping v1
        //this.parent.resetAbsolutePos();  //resolve snapping v2

        //move points for the parallel line
        const parallelLine = this.getParallelLine();
        parallelLine.from.x += xDiff;
        parallelLine.to.x += xDiff;
      }
    } else if (o === orientation.HORIZONTAL) {
      if (lineDirection === DIRECTIONS.WEST) {
        newImageHeight -= yDiff;
        this.from.y -= yDiff;
        this.to.y -= yDiff;
      } else if (lineDirection === DIRECTIONS.EAST) {
        newImageHeight += yDiff;
        this.parent.setPosition({x: this.parent.pos.x, y: this.parent.pos.y - yDiff});
        this.parent.updateSnappedPos(); //resolve snapping v1
        //this.parent.resetAbsolutePos(); //resolve snapping v2

        //move points for the parallel line
        const parallelLine = this.getParallelLine();
        parallelLine.from.y += yDiff;
        parallelLine.to.y += yDiff;
      }
    } else {
      const nextLine = this.parent.getNextLine(this);
      const prevLine = this.parent.getPrevLine(this);
      moveDiagonalLine(this, nextLine, prevLine, this.state.movePointDistance, yDiff, o);
      //newImageWidth += xDiff;
      //newImageHeight += yDiff;
    }

    this.parent.updateLinesLength();
    this.updatePrentSize(newImageWidth, newImageHeight);
  }

  updatePrentSize = (newImageWidth, newImageDepth) => {
    const imageState = this.parent.getState();
    if (newImageDepth >= imageState.minimumDepth && newImageWidth >= imageState.minimumWidth ) {
      this.parent.setSize({
        width: +newImageWidth,
        depth: +newImageDepth
      });
    }

    SqftStore.updateCalculations();
  }

  updateLineLength = () => {
    const midPoint = getMidPoint(this.from, this.to);
    const distance = getPointDistance(this.from, this.to);
    this.lineLengthText.pos.x = midPoint.x;
    this.lineLengthText.pos.y = midPoint.y;
    this.lineLengthText.value = distance;
  }

  getLineDirection = () => {
    const prevLine = this.parent.getPrevLine(this);
    const nextLine = this.parent.getNextLine(this);

    return getPointDirection(this.from, this.to, nextLine.to, prevLine.from);
  }

  render = (ctx) => {
    this.renderHovering(ctx);
  }

  renderHovering = (ctx) => {
    const reduxState = store.getState();
    const activeButton = reduxState.sqftMenuState.activeButton;
    if (this.state.isHovering && activeButton === SIDEBAR_NAVIGATION_BUTTONS.resize) {
      let pointFieldFrom = getPointField(this.from.x, this.from.y, this.parent);
      let pointFieldTo = getPointField(this.to.x, this.to.y, this.parent);
      void pointFieldFrom;
      void pointFieldTo;
      void ctx;

      ctx.beginPath();
      ctx.lineWidth = 3;
      ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].primary;
      ctx.moveTo(pointFieldFrom.x, pointFieldFrom.y);
      ctx.lineTo(pointFieldTo.x, pointFieldTo.y);

      ctx.stroke();
      ctx.closePath();
    }
  }

  getParallelLine = () => {
    const lines = this.parent.getLines();
    const lineIndex = lines.indexOf(this);
    const parallelLineIndex = (lineIndex + 2) % 4;

    return lines[parallelLineIndex];
  }

  getOffset = () => {
    let scale = sqftConfig.scale;
    let workspacePos = workspace.getOffset();
    if (this.parent) {
      let _pos = this.parent.getPosition();
      if (sqftConfig.workspace.snapToGrid) {
        _pos = this.parent.getSnappedPosition();
      }
      return {
        x: workspacePos.x + (_pos.x * scale),
        y: workspacePos.y + (_pos.y * scale)
      }
    } else {
      return {x: 0, y: 0};
    }
  };

  deleteAttachedItem = () => {
    return true
  }

  isWithBumpout = () => {
    return false
  }

  isWithMitered = () => {
    return false
  }
}

export default SimpleLine;
